import axios from 'axios';
import { API_BASE_URL } from '../../../config';

const EDIT_PAYMENT_ENDPOINT_BY_LOCATION = Object.freeze({
  transactions: 'information',
  approvals: 'approval-information',
  'processing-exceptions': 'processing-exception',
  'communication-exceptions': 'communication-exception',
});

export class PaymentsApi {
  static createPayment = (formData) => {
    return axios.post(`${API_BASE_URL}/payments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  static updatePayment = (payment, paymentLocation, formData, updateStatus) => {
    const endpointLocation = EDIT_PAYMENT_ENDPOINT_BY_LOCATION[paymentLocation];

    if (!endpointLocation) {
      throw new Error(
        `Invalid paymentLocation "${paymentLocation}". Expected one of: ${Object.keys(
          EDIT_PAYMENT_ENDPOINT_BY_LOCATION,
        ).join(', ')}`,
      );
    }

    return axios.patch(
      `${API_BASE_URL}/payments/${payment.id}/${endpointLocation}`,
      formData,
      {
        params: {
          update_status: updateStatus,
          facility_id: payment.facility_id,
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  };

  static cancelPayment = (paymentId, comment) => {
    return axios.post(API_BASE_URL + `/payments/${paymentId}/cancel`, {
      comment: comment,
    });
  };

  static deletePayment = (paymentId) => {
    return axios.delete(API_BASE_URL + `/payments/${paymentId}`);
  };

  static restorePayment = (paymentId) => {
    return axios.post(API_BASE_URL + `/payments/${paymentId}/restore`);
  };

  static resendCommunication = (paymentId) => {
    return axios.post(
      `${API_BASE_URL}/payments/${paymentId}/resend-communication`,
    );
  };
}
